import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'role';

export const TEST_ID = 'roleMultiSelectPanelField';
